import { supporterMonthlyStatsQuery } from "@/api/reporting";
import { DataTable } from "@/components/data-table/DataTable";
import { DataTableBody } from "@/components/data-table/DataTableBody";
import { PointsAmount } from "@/components/PointsAmount";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { getMonthName } from "@common/utils/date";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/reports/$countryCode/supporter")({
  component: SupporterMonthlyStatsReportPage,
  beforeLoad: () => ({
    breadcrumb: "Supporter Monthly Stats",
  }),
});

function SupporterMonthlyStatsReportPage() {
  const { countryCode } = Route.useParams();
  const supporterDataQuery = useQuery(supporterMonthlyStatsQuery(countryCode));

  return (
    <PageWrapper title="Supporter — Monthly Stats">
      <DataTable>
        <DataTableBody
          data={supporterDataQuery.data ?? []}
          status={supporterDataQuery.status}
          rounded="full"
          columns={[
            {
              header: "Year",
              cell: "year",
            },
            {
              header: "Month",
              cell: d => getMonthName(d.month - 1),
            },
            {
              header: "# Supporters",
              cell: "num_supporters",
            },
            {
              header: "Avg Points / Supporter",
              cell: c => <PointsAmount amount={c.avg_tokens_per_supporter} tokenCurrency={c.token_currency_code} />,
              formatter: "number",
            },
            {
              header: "Points Total",
              cell: c => <PointsAmount amount={c.tokens_total} tokenCurrency={c.token_currency_code} />,
              formatter: "number",
            },
            {
              header: "TOK",
              cell: "token_currency_code",
            },
            {
              header: "Avg Spend / Supporter",
              cell: d => (d.avg_spend_per_supporter_cents / 100).toFixed(2),
              formatter: "currency",
            },
            {
              header: "Total Spend",
              cell: d => (d.spend_total_cents / 100).toFixed(2),
              formatter: "currency",
            },
            {
              header: "$",
              cell: "currency_code",
              formatter: "uppercase",
            },
          ]}
          dataKey="month"
        />
      </DataTable>
    </PageWrapper>
  );
}
